
















import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class SimpleMap extends Vue {
  loaded = false;
  iframe = {
    src:
      "https://www.openstreetmap.org/export/embed.html?bbox=-58.983165621757514%2C-27.45269893600231%2C-58.979625105857856%2C-27.450161645487285&amp;layer=mapnik&amp;marker=-27.45143029804113%2C-58.98139536380768",
    style: {},
    wrapperStyle: {},
  };

  mounted() {
    let googleMap = this.$refs.iframeMap;
    if (this.$vuetify.breakpoint.smAndDown) {
      this.iframe.style = {
        position: "relative",
        width: "315",
        height: "182",
        borderRadius: "25px",
      };
      this.iframe.wrapperStyle = {
        overflow: "hidden",
        borderRadius: "25px",
        height: "182",
        width: "315",
        frameborder: "0",
      };
    } else {
      this.iframe.style = {
        position: "relative",
        width: "600",
        height: "272",
        borderRadius: "25px",
      };
      this.iframe.wrapperStyle = {
        overflow: "hidden",
        borderRadius: "25px",
        height: "272",
        width: "600",
        frameborder: "0",
      };
    }
    this.loaded = true;

    /*
   <iframe
   width="425"
   height="350"
   frameborder="0"
   scrolling="no"
   marginheight="0"
   marginwidth="0"
   src="https://www.openstreetmap.org/export/embed.html?bbox=-58.983165621757514%2C-27.45269893600231%2C-58.979625105857856%2C-27.450161645487285&amp;layer=mapnik&amp;marker=-27.45143029804113%2C-58.98139536380768"
   style="border: 1px solid black">
   </iframe><br/><small>
   <a href="https://www.openstreetmap.org/?mlat=-27.45143&amp;mlon=-58.98140#map=19/-27.45143/-58.98140">Ver mapa más grande</a></small>
    */
  }
}
